// extracted by mini-css-extract-plugin
module.exports = {"empty":"MnWuemK4sBELNDu6d2GJ"};